import React from 'react';
import PropTypes from 'prop-types';
import './DashboardCard.css';

function DashboardCard({ 
  title, 
  count, 
  description, 
  backgroundColor = '#EE8F3B', 
  icon: Icon,
  onShowAll,
  actionLabel = 'Pokaż wszystkie',
  secondaryCount,
  secondaryDescription,
  secondaryAction,
  secondaryActionLabel = 'Zgłoszenia wiadomości'
}) {
  return (
    <div className="dashboard-card" style={{ backgroundColor }}>
      <div className="dashboard-card__content">
        <div className={`dashboard-card__info${secondaryAction ? ' dashboard-card__info--split' : ''}`}>
          <span className="dashboard-card__title">{title}</span>
          <div className={`dashboard-card__stats${secondaryCount !== undefined ? ' dashboard-card__stats--split' : ''}`}>
            <div className="dashboard-card__stat-item">
              <span className="dashboard-card__count">{count}</span>
              <span className="dashboard-card__description">{description}</span>
            </div>
            {secondaryCount !== undefined && (
              <div className="dashboard-card__stat-item">
                <span className="dashboard-card__count">{secondaryCount}</span>
                <span className="dashboard-card__description">{secondaryDescription}</span>
              </div>
            )}
          </div>
          <div className={`dashboard-card__actions${secondaryAction ? ' dashboard-card__actions--split' : ''}`}>
            <button className="dashboard-card__button" onClick={onShowAll}>{actionLabel}</button>
            {secondaryAction && <button className="dashboard-card__button dashboard-card__button--secondary" onClick={secondaryAction}>{secondaryActionLabel}</button>}
          </div>
          {false && <button>
            Pokaż wszystkie
          </button>}
        </div>
      </div>
      {Icon && (
        <div className="dashboard-card__icon-wrapper">
          <Icon className="dashboard-card__icon" />
        </div>
      )}
    </div>
  );
}

DashboardCard.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  description: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  icon: PropTypes.elementType,
  onShowAll: PropTypes.func,
  actionLabel: PropTypes.string,
  secondaryCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  secondaryDescription: PropTypes.string,
  secondaryAction: PropTypes.func,
  secondaryActionLabel: PropTypes.string,
};

DashboardCard.defaultProps = {
  backgroundColor: '#EE8F3B',
  onShowAll: () => {},
};

export default DashboardCard;

